import request from '@/utils/request'

// 修改照片
export function UploadPic(data) {
    return request({
        url: '/resource/File/UploadPic',
        method: 'post',
        data
    })
}

//获取用户信息
export function GetPmiUser(params) {
    return request({
        url: '/api/PmiUser/Get',
        method: 'get',
        params
    })
}

// 资源标签
//通过字典id查询数据
export function getPmiDic(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}

// 提交学习标签 /api/Center/UpdateLabel
export function UpdateLabel(params) {
    return request({
        url: '/api/Center/UpdateLabel',
        method: 'GET',
        params
    })
}



// 获取考试标签 ?NamespaceId=6
export function GetByTypeIdk(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}


// 根据id查询个人信息的其他信息 
export function PmiUserOthergetList(params) {
    return request({
        url: '/api/PmiUser/Get',
        method: 'get',
        params
    })
}


//修改用户信息
export function UploadPmiUser(data) {
    return request({
        url: '/api/PmiUser/Update',
        method: 'post',
        data
    })
}
//获取密码正则
export function PmiPwdSetget(params) {
    return request({
        url: '/api/PmiPwdSet/Get',
        method: 'get',
        params
    })
}


//活动模块接口

//获取活动列表
export function LoadActivityInfo(params) {
    return request({
        url: '/api/ActivityInfo/Load',
        method: 'get',
        params
    })
}

// 获取消息 /api/Center/GetMesList
export function GetMesListmsg(params) {
    return request({
        url: '/api/Center/GetMesList',
        method: 'get',
        params
    })
}

// 标签赋值 /
export function GetLabelList(params) {
    return request({
        url: '/api/Center/GetLabel',
        method: 'get',
        params
    })
}


//获取单个活动的评分标准
export function GetRuleActivityInfo(params) {
    return request({
        url: '/api/ActivityInfo/GetRule',
        method: 'get',
        params
    })
}
//获取单个活动的基本资料
export function GetActivityInfo(params) {
    return request({
        url: '/api/ActivityInfo/Get',
        method: 'get',
        params
    })
}

// 成绩结果 /api/ActivityResource/CjInfo
export function ActivityResource(params) {
    return request({
        url: '/api/ActivityResource/CjInfo',
        method: 'get',
        params
    })
}

//活动报名
export function AddActivityResource(data) {
    return request({
        url: '/api/ActivityResource/Add',
        method: 'post',
        data
    })
}

//活动评分
export function AddScoreActivityResource(data) {
    return request({
        url: '/api/ActivityResource/AddScore',
        method: 'post',
        data
    })
}



//批量删除
export function DeleteActivityResource(data) {
    return request({
        url: '/api/ActivityResource/Delete',
        method: 'post',
        data
    })
}


//获取单个报名的数据
export function GetActivityResource(params) {
    return request({
        url: '/api/ActivityResource/Get',
        method: 'get',
        params
    })
}
//获取单个报名的评分数据
export function GetScoreActivityResource(params) {
    return request({
        url: '/api/ActivityResource/GetScore',
        method: 'get',
        params
    })
}

//获取该活动的所有报名数据
export function LoadActivityResource(params) {
    return request({
        url: '/api/ActivityResource/Load',
        method: 'get',
        params
    })
}

// 审核
export function PassActivityResource(data) {
    return request({
        url: '/api/ActivityResource/Pass',
        method: 'post',
        data
    })
}

// 微课评比页面作品审核模块
export function PassInfoActivityResource(params) {
    return request({
        url: '/api/ActivityResource/PassInfo',
        method: 'get',
        params
    })
}

// 活动评价
export function PjInfoActivityResource(params) {
    return request({
        url: '/api/ActivityResource/PjInfo',
        method: 'get',
        params
    })
}
// 修改活动
export function UpdateActivityResource(data) {
    return request({
        url: '/api/ActivityResource/Update',
        method: 'post',
        data
    })
}
// 修改分值
export function UpdateScoreActivityResource(data) {
    return request({
        url: '/api/ActivityResource/UpdateScore',
        method: 'post',
        data
    })
}

//添加博客
export function TeacherBlogsAdd(data) {
    return request({
        url: '/api/TeacherBlogs/Add',
        method: 'post',
        data
    })
}

//删除博客
export function TeacherBlogsDelete(data) {
    return request({
        url: '/api/TeacherBlogs/Delete',
        method: 'post',
        data
    })
}
//获取单个博客数据
export function TeacherBlogsGet(params) {
    return request({
        url: '/api/TeacherBlogs/Get',
        method: 'get',
        params
    })
}
//获取博客数据列表
export function TeacherBlogsLoad(params) {
    return request({
        url: '/api/TeacherBlogs/Load',
        method: 'get',
        params
    })
}
// 修改博客
export function TeacherBlogsUpdate(data) {
    return request({
        url: '/api/TeacherBlogs/Update',
        method: 'post',
        data
    })
}
//我的考试记录
export function getMyExam(params) {
    return request({
        url: '/api/Exam/GetMyExam',
        method: 'get',
        params
    })
}

//推送的资源
export function getDocumentList(params) {
    return request({
        url: '/api/Center/GetDocumentList',
        method: 'get',
        params
    })
}

//推送的考试
export function getExamtList(params) {
    return request({
        url: '/api/Center/GetExamtList',
        method: 'get',
        params
    })
}

//推送的课程
export function getMoocList(params) {
    return request({
        url: '/api/Center/GetMoocList',
        method: 'get',
        params
    })
}
//我训历的调训
export function getMyTrainOver(params) {
    return request({
        url: '/api/Center/GetMyTrain',
        method: 'get',
        params
    })
}
//我训历的考试
export function getMyExamOver(params) {
    return request({
        url: '/api/Center/GetMyExamOver',
        method: 'get',
        params
    })
}

// 我的收藏
export function GetCollectionListCenter(params) {
    return request({
        url: '/api/Center/GetCollectionList',
        method: 'get',
        params
    })
}

// 删除收藏 
export function CollectionDele(params) {
    return request({
        url: '/api/Collection/Delete',
        method: 'get',
        params
    })
}
// 点击观看观看数加1
export function DocumentRead(id, params) {
    return request({
        url: '/api/Document/Read?id=' + id,
        method: 'GET',
        params
    })
}
export function getRead(params) {
    return request({
        url: '/api/Document/Read',
        method: 'GET',
        params
    })
}
export function isLearn(params) {
    return request({
        url: '/api/Center/IsLearn',
        method: 'GET',
        params
    })
}


// 我的证书
export function CenterMyCerInfoList(params) {
    return request({
        url: '/api/Center/MyCerInfoList',
        method: 'get',
        params
    })
}

// 删除收藏 
export function GetCenterTaskTrain(params) {
    return request({
        url: '/api/TrainTask/GetCenterTaskTrain',
        method: 'get',
        params
    })
}

// 获取我的调训资料
export function TrainInfoGetMyTrain(params) {
    return request({
        url: '/api/TrainInfo/GetMyTrain',
        method: 'get',
        params
    })
}

// 获取我的测评
export function TrainInfoGetMyPoll(params) {
    return request({
        url: '/api/TrainInfo/GetMyPoll',
        method: 'get',
        params
    })
}

// 证书展示页面
export function GetCerDataDetail(params) {
    return request({
        url: '/api/CerInfo/GetCerDataDetail',
        method: 'get',
        params
    })
}
// 我的学习情况
export function myLearnInfoList(params) {
    return request({
        url: '/api/Center/MyLearnInfoList',
        method: 'get',
        params
    })
}

//录入训历
export function TrainSelfAdd(data) {
    return request({
        url: '/api/TrainSelf/Add',
        method: 'post',
        data
    })
}
export function getCourseList(params) {
    return request({
        url: '/api/TrainJoin/GetCourseList',
        method: 'get',
        params
    })
}
export function getLearnOver(params) {
    return request({
        url: '/api/TrainJoin/GetLearnOver',
        method: 'get',
        params
    })
}
export function getOfficial(params) {
    return request({
        url: '/api/TrainJoin/GetOfficial',
        method: 'get',
        params
    })
}
export function getExam(params) {
    return request({
        url: '/api/TrainJoin/GetExamByUser',
        method: 'get',
        params
    })
}
export function addRecord(params) {
    return request({
        url: '/api/TrainJoin/AddRecord',
        method: 'get',
        params
    })
}

export function getSelf(params) {
    return request({
        url: '/api/ActivityResource/GetSelf',
        method: 'get',
        params
    })
}


export function DeleteMes(params) {
    return request({
        url: '/api/Center/DeleteMes',
        method: 'get',
        params
    })
}


export function isPj(data) {
    return request({
        url: '/api/ActivityResource/IsPj',
        method: 'post',
        data
    })
}
export function isSubmit(data) {
    return request({
        url: '/api/ActivityResource/IsSubmit',
        method: 'post',
        data
    })
}
export function getLoadQT(params) {
    return request({
        url: '/api/ActivityInfo/LoadQT',
        method: 'get',
        params
    })
}

// 获取学习记录 
export function GetNoteRecord(params) {
    return request({
        url: '/api/Center/GetNoteRecord',
        method: 'get',
        params
    })
}

// 删除学习记录 
export function DeleteNoteRecord(params) {
    return request({
        url: '/api/Center/DeleteNoteRecord',
        method: 'get',
        params
    })
}
export function isUpload(params) {
    return request({
        url: '/api/ActivityResource/IsUpload',
        method: 'get',
        params
    })
}

// 获取消息数量
export function GetMesCountst(params) {
    return request({
        url: '/api/Center/GetMesCount',
        method: 'get',
        params
    })
}

// 确认未读 
export function GetMesPassSt(params) {
    return request({
        url: '/api/Center/GetMesPass',
        method: 'get',
        params
    })
}
export function getUserScoreByUserId(params) {
    return request({
        url: '/api/TrainSubject/GetUserScoreByUserId',
        method: 'get',
        params
    })
}


// 添加成绩 
export function TeacherExamAdd(data) {
    return request({
        url: '/api/TeacherExam/Add',
        method: 'post',
        data: data
    })
}

export function TeacherExamDelete(data) {
    return request({
        url: '/api/TeacherExam/Delete',
        method: 'post',
        data: data
    })
}


export function TeacherExamUpdate(data) {
    return request({
        url: '/api/TeacherExam/Update',
        method: 'post',
        data: data
    })
}


export function TeacherExamGet(params) {
    return request({
        url: '/api/TeacherExam/Get',
        method: 'get',
        params
    })
}

// 添加证书 
export function TeacherCerAdd(data) {
    return request({
        url: '/api/TeacherCer/Add',
        method: 'post',
        data: data
    })
}

// 更新证书 
export function TeacherCerUpdate(data) {
    return request({
        url: '/api/TeacherCer/Update',
        method: 'post',
        data: data
    })
}



export function TeacherCerGet(params) {
    return request({
        url: '/api/TeacherCer/Get',
        method: 'get',
        params
    })
}

export function CenterGetDocUnitList(params) {
    return request({
        url: '/api/Center/GetDocUnitList',
        method: 'get',
        params
    })
}

export function TeacherCerDelete(data) {
    return request({
        url: '/api/TeacherCer/Delete',
        method: 'post',
        data: data
    })
}

//获取教官日志列表
export function getTeachrJingLiApi(params) {
    return request({
        url: '/api/TrainInfo/GetTeacherTrain',
        method: 'get',
        params
    })
}

//获取教官的日程安排
export function getTeachrJournalApi(params) {
    return request({
        url: '/api/TrainInfo/GetTeacherSchedule',
        method: 'get',
        params
    })
}

//获取教官日志信息
export function getTeachrLogInfoApi(params) {
    return request({
        url: '/api/TrainSchedule/GetMes',
        method: 'get',
        params
    })
}

//更新教官日志
export function updateTeachrLogInfoApi(data) {
    return request({
        url: '/api/TrainSchedule/TeacherSchedule',
        method: 'post',
        data: data
    })
}


//获取班级管理列表
export function getclassTearchLogListApi(params) {
    return request({
        url: '/api/TrainInfo/GetMasterTrain',
        method: 'get',
        params
    })
}

//获取班主任的日程安排列表
export function getClassMasterJournalApi(params) {
    return request({
        url: '/api/TrainInfo/GetMasterSchedule',
        method: 'get',
        params
    })
}

//获取班主任日志信息
export function getClassMasterLogInfoApi(params) {
    return request({
        url: '/api/TrainSchedule/GetMasterMes',
        method: 'get',
        params
    })
}

//更新班主任日志
export function updateClassMasterLogInfoApi(data) {
    return request({
        url: '/api/TrainSchedule/MasterSchedule',
        method: 'post',
        data: data
    })
}

//心理测评列表
export function GetTopiccenterList(params) {
    return request({
        url: '/api/HeartCenter/GetTopicList',
        method: 'get',
        params
    })
}